
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcAlertIcon as ObcAlertIconElement} from '@oicl/openbridge-webcomponents/dist/components/alert-icon/alert-icon.js';
 
 
 

 
 export const ObcAlertIcon = createComponent({
   react: React,
   tagName: 'obc-alert-icon',
   elementClass: ObcAlertIconElement,
   events: {
     
   }
  });
 
 